import { FieldDefinition } from '../../../App/apiWrapper';
import { FieldIndex } from '../index';
import { getRootAttribute } from './getRootAttribute';
import { getUiFieldIndices } from './getUiFieldIndices';

export const indexedUiElementId = (fieldDefinition: FieldDefinition, fieldIndices: FieldIndex[]): string => {
  const indices: FieldIndex[] = getUiFieldIndices(fieldDefinition, fieldIndices);
  return getRootAttribute(fieldDefinition.elementId, indices, (value) => value.uiIdxVar);
};
